import dateFnFormat from 'date-fns/format'
import { Locale } from 'date-fns'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

/**
 *  locale: Locale object
 *  weekStartsOn: the index of the first day of the week (0 - Sunday)
 *  firstWeekContainsDate: the day of January, which is
 *  useAdditionalWeekYearTokens: if true, allows usage of the week-numbering year tokens YY and YYYY; see: https://git.io/fxCyr
 *  useAdditionalDayOfYearTokens: if true, allows usage of the day-numbering year tokens DDD and DDDD; see: https://git.io/fxCyr
 */

type Options = {
  locale?: Locale
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6
  firstWeekContainsDate?: number
  useAdditionalWeekYearTokens?: boolean
  useAdditionalDayOfYearTokens?: boolean
}

const format = (
  dateProp: dateParamType,
  formatString: string,
  options?: Options,
): string => {
  const date = toDate(dateProp)
  const result = dateFnFormat(date, formatString, options)
  return result
}

export default format
